import * as React from "react";
import styled from "styled-components";
import {PageProps} from "gatsby";
import {Layout} from "@/containers/Layout";
import {PageTitle} from "@/components/PageTitle";
// @ts-ignore
import ImgActivitiesPNG from "../images/v0.7/activity_background.png";
// @ts-ignore
import ImgActivitiesWEBP from "../images/v0.7/activity_background.webp";
import {classes} from "@/utils";
import {PrimaryText} from "@/components/span-primary";
import {Steps} from "@/components/Steps";
import {MCSignupForm} from "@/components/mc_signup_form";

export default function PledgeStep2(props: PageProps) {
    React.useEffect(() => {
        // Load Mailchimp validation script
        const script = document.createElement('script');
        script.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            // First, intercept jQuery AJAX calls before initializing Mailchimp
            const interceptScript = document.createElement('script');
            interceptScript.innerHTML = `
                (function() {
                    // Store the original jQuery ajax method
                    var originalAjax = jQuery.ajax;
                    
                    // Override jQuery.ajax
                    jQuery.ajax = function(options) {
                        // Check if this is a Mailchimp submission
                        if (options.url && options.url.includes('list-manage.com/subscribe/post-json')) {
                            // Store the original success callback
                            var originalSuccess = options.success;
                            
                            // Override the success callback
                            options.success = function(data) {
                                // Call the original success callback first
                                if (originalSuccess) {
                                    originalSuccess.call(this, data);
                                }
                                
                                // Check if submission was successful
                                if (data && data.result === 'success') {
                                    // Save email to localStorage only on success
                                    const emailValue = document.getElementById('mce-EMAIL').value;
                                    if (emailValue) {
                                        localStorage.setItem('prepledge_email', emailValue);
                                    }
                                    
                                    // Add a small delay to ensure Mailchimp's UI updates
                                    setTimeout(function() {
                                        // Redirect to payment page
                                        window.location.href = '/pledge_subscription_handler';
                                    }, 500);
                                }
                            };
                        }
                        
                        // Call the original ajax method with potentially modified options
                        return originalAjax.call(this, options);
                    };
                })();
            `;
            document.body.appendChild(interceptScript);

            // Now initialize Mailchimp form
            const initScript = document.createElement('script');
            initScript.innerHTML = `
                (function($) {
                    window.fnames = new Array(); 
                    window.ftypes = new Array();
                    fnames[0]='EMAIL';ftypes[0]='email';
                    fnames[1]='FNAME';ftypes[1]='text';
                    fnames[2]='LNAME';ftypes[2]='text';
                    fnames[3]='ADDRESS';ftypes[3]='address';
                    fnames[4]='PHONE';ftypes[4]='phone';
                    fnames[6]='SUBINTENT';ftypes[6]='radio';
                    fnames[5]='USERPLAN';ftypes[5]='dropdown';
                    fnames[7]='MMERGE7';ftypes[7]='dropdown';                    
                }(jQuery));
                var $mcj = jQuery.noConflict(true);
            `;
            document.body.appendChild(initScript);
        };

        return () => {
            // Cleanup scripts on unmount
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []);

    return (
        <>
            <div id={"pre-pledge"} className={'w-0 h-0 opacity-0'}/>
            <Container {...props} meta={{title: 'Pre-Pledge'}} navBarProps={{actionButtons: false}}>
                <Content/>
            </Container>
        </>
    )
}

function Content() {
    return (
        <div className={"max-w-1200 py-4 mb-24"}>
            <div className="text-center mb-8">
                <PageTitle w1={<>Pre-<PrimaryText>Pledge</PrimaryText></>}/>
            </div>
            <div className={'sm:px-8 max-w-full lg:px-2 px-4 md:px-8'}>
                <div className="text-center mb-8">
                    <div className={`${classes.text_1_4} font-bold mb-4 text-primary`}>
                        Help us launch faster!
                    </div>
                    <div className={`${classes.text_b_1} opacity-90 mb-6`}>
                        Pre-pledge to our Kickstarter campaign and get exclusive early access rewards.
                    </div>
                </div>
                <Steps steps={["active", "inactive"]}/>
                <div className="mt-4 text-center mb-6">
                    <div className={`${classes.text_b_2} font-bold text-primary opacity-90`}>
                        Set up your details
                    </div>
                </div>

                <div className="flex justify-center">
                    <div className="max-w-2xl">
                        <MCSignupForm buttonText={"Next"} postSuccessJQuery={`
                                    // Save email to localStorage only on success
                                    const emailValue = document.getElementById('mce-EMAIL').value;
                                    if (emailValue) {
                                        localStorage.setItem('prepledge_email', emailValue);
                                    }
                        `} postSuccessRedirectUrl={`/pledge_subscription_handler`}/>
                    </div>
                </div>
            </div>
        </div>

    );
}

const Container = styled(Layout)`
    background: var(--bg-top);
    background: radial-gradient(ellipse at 30% 0%, var(--bg-top), var(--bg-bottom) 80%);

    .glass-card {
        border-radius: 16px;
        border: 1.5px solid rgba(255, 255, 255, 0.60);
        background: rgba(255, 193, 7, 0.25);
        backdrop-filter: blur(25px);
        color: white;
    }

    /* Mailchimp form overrides - golden glass card style */

    #mc_embed_signup {
        border-radius: 16.324px;
        border: 1.632px solid rgba(255, 255, 255, 0.60);
        background: rgba(255, 193, 7, 0.25);
        backdrop-filter: blur(25px);
        clear: left;
        font: 14px Helvetica, Arial, sans-serif;
        width: 100%;
        max-width: 600px;
        padding: 20px;
        color: white;
    }

    #mc-embedded-subscribe-form input[type=checkbox] {
        display: inline;
        width: auto;
        margin-right: 10px;
    }

    #mergeRow-gdpr {
        margin-top: 20px;
    }

    #mergeRow-gdpr fieldset label {
        font-weight: normal;
    }

    #mc-embedded-subscribe-form .mc_fieldset {
        border: none;
        min-height: 0px;
        padding-bottom: 0px;
    }

    /* Style the submit button to match your theme */

    #mc-embedded-subscribe {
        //background-color: #ffc107;
        //color: #000;
        //font-weight: bold;
        //padding: 12px 24px;
        //border: none;
        //border-radius: 8px;
        //cursor: pointer;
        //transition: all 0.3s ease;
    }

    #mc-embedded-subscribe:hover {
        background-color: #ffb300;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }



`;